import { render, staticRenderFns } from "./AccidentsPolicy.vue?vue&type=template&id=49739e20&scoped=true&"
import script from "./AccidentsPolicy.vue?vue&type=script&lang=js&"
export * from "./AccidentsPolicy.vue?vue&type=script&lang=js&"
import style0 from "./AccidentsPolicy.vue?vue&type=style&index=0&id=49739e20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49739e20",
  null
  
)

export default component.exports